import { render, staticRenderFns } from "./Agreem.vue?vue&type=template&id=58f31ffe&"
import script from "./Agreem.vue?vue&type=script&lang=js&"
export * from "./Agreem.vue?vue&type=script&lang=js&"
import style0 from "./Agreem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports